<template>
  <i
    v-tooltip="tooltip"
    class="
      fa fa-check
      tw-ring-inset
      tw-ring
      tw-ring-sf-snow-lighter
      tw-ring-offset-1
      tw-rounded-full
      tw-w-8
      tw-h-8
      tw-p-2
      tw-flex
      tw-items-center
      tw-justify-center
      tw-text-base
      tw-leading-4
    "
    :class="iconClasses"
    data-testid="todo-toggle"
    @click.prevent="handleClick"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

const I18n = useI18n()
const emit = defineEmits<{ toggle: [] }>()

interface Props {
  done: boolean
  canEdit: boolean
}

const props = withDefaults(defineProps<Props>(), {
  done: () => false,
  canEdit: () => false,
})

const tooltip = computed(() =>
  props.canEdit ? I18n.t(`communication.todos.toggle.${props.done}`) : ''
)

const iconClasses = computed(() => ({
  'tw-cursor-pointer': props.canEdit,
  'tw-ring-sf-snow-lighter': props.canEdit,
  'tw-ring-offset-sf-neutral-light-1': props.canEdit,
  'hover:tw-ring-offset-sf-neutral-light-2': props.canEdit,
  'tw-ring-sf-snow': !props.canEdit,
  'tw-ring-offset-sf-snow-dark': !props.canEdit,
  'tw-text-sf-snow-lighter': props.done,
  'tw-text-transparent': !props.done,
  'tw-bg-sf-success-light-1': props.done && props.canEdit,
  'tw-bg-sf-snow': !props.done,
  'hover:tw-bg-sf-success-light-2': props.done && props.canEdit,
  'tw-bg-sf-snow-darker': props.done && !props.canEdit,
  'hover:tw-text-sf-success-light-1': !props.done && props.canEdit,
}))

function handleClick() {
  if (props.canEdit) {
    emit('toggle')
  }
}
</script>
